import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  updater: {
    id: 'core.lookupBox.updater',
    defaultMessage: 'Generate',
  },
  ellipsis: {
    id: 'core.lookupBox.dictionary',
    defaultMessage: 'Open dictionary',
  },
});
